var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewdriver = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.99541C9 2.34109 10.3431 1 12 1C13.6569 1 15 2.34109 15 3.99541C15 5.64973 13.6569 6.99082 12 6.99082C10.3431 6.99082 9 5.64973 9 3.99541ZM7 13.9801H17C17.3466 13.9791 17.6679 13.7989 17.8492 13.504C18.0305 13.209 18.046 12.8414 17.89 12.5323L16.94 10.6352C16.43 9.62474 15.3933 8.98742 14.26 8.98776H9.74C8.60672 8.98742 7.56997 9.62474 7.06 10.6352L6.11 12.5323C5.95403 12.8414 5.96945 13.209 6.15076 13.504C6.33207 13.7989 6.6534 13.9791 7 13.9801ZM14.61 15.9771H18.5C18.6429 15.9632 18.7852 16.009 18.8932 16.1035C19.0012 16.1981 19.0651 16.333 19.07 16.4763V20.3603C19.0775 20.565 18.9566 20.7527 18.7669 20.8307C18.5772 20.9086 18.359 20.8604 18.22 20.7098L17.22 19.7113C15.4687 21.6353 12.7926 22.4297 10.2731 21.7735C7.75354 21.1173 5.80699 19.1191 5.22 16.5861C5.19221 16.4385 5.22857 16.286 5.32 16.1668C5.41335 16.0464 5.55752 15.9763 5.71 15.9771H6.71C6.9216 15.9714 7.11387 16.0993 7.19 16.2966C7.68105 18.0497 9.08883 19.3969 10.8638 19.8125C12.6389 20.228 14.4997 19.646 15.72 18.2935L14.26 16.8258C14.1199 16.6831 14.0785 16.4709 14.1547 16.2862C14.2309 16.1015 14.41 15.9799 14.61 15.9771Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewdriver, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/New driver.dff4889d.svg";
export { ForwardRef as ReactComponent };